export class CSVProcessor {
  static parseCSVLine(line) {
    const cells = [];
    let current = '';
    let inQuotes = false;
    for (let i = 0; i < line.length; i++) {
      const ch = line[i];
      if (ch === '"') { inQuotes = !inQuotes; }
      else if (ch === ',' && !inQuotes) { cells.push(current.trim()); current = ''; }
      else { current += ch; }
    }
    cells.push(current.trim());
    return cells;
  }
  static convertDateFormat(dateStr) {
    const trimmed = dateStr.trim();
    
    // Pattern 1: DD-MM-YY HH:MM (e.g., 16-02-26 11:17)
    const pattern1 = /^(\d{2})-(\d{2})-(\d{2})\s+(\d{2}:\d{2})$/;
    const match1 = trimmed.match(pattern1);
    if (match1) {
      const [, day, month, year, time] = match1;
      const fullYear = `20${year}`;
      return `${fullYear}-${month}-${day} ${time}`;
    }
    
    // Pattern 2: DD/MM/YY HH:MM (e.g., 16/02/26 11:17)
    const pattern2 = /^(\d{2})\/(\d{2})\/(\d{2})\s+(\d{2}:\d{2})$/;
    const match2 = trimmed.match(pattern2);
    if (match2) {
      const [, day, month, year, time] = match2;
      const fullYear = `20${year}`;
      return `${fullYear}-${month}-${day} ${time}`;
    }
    
    // Pattern 2b: M/DD/YY HH:MM (e.g., 2/16/26 13:01) - SINGLE DIGIT MONTH
    const pattern2b = /^(\d{1,2})\/(\d{1,2})\/(\d{2})\s+(\d{2}:\d{2})$/;
    const match2b = trimmed.match(pattern2b);
    if (match2b) {
      const [, month, day, year, time] = match2b;
      const fullYear = `20${year}`;
      const paddedMonth = month.padStart(2, '0');
      const paddedDay = day.padStart(2, '0');
      return `${fullYear}-${paddedMonth}-${paddedDay} ${time}`;
    }
    
    // Pattern 3: DD-MM-YYYY HH:MM (e.g., 16-02-2026 11:17)
    const pattern3 = /^(\d{2})-(\d{2})-(\d{4})\s+(\d{2}:\d{2})$/;
    const match3 = trimmed.match(pattern3);
    if (match3) {
      const [, day, month, year, time] = match3;
      return `${year}-${month}-${day} ${time}`;
    }
    
    // Pattern 4: DD/MM/YYYY HH:MM (e.g., 16/02/2026 11:17)
    const pattern4 = /^(\d{2})\/(\d{2})\/(\d{4})\s+(\d{2}:\d{2})$/;
    const match4 = trimmed.match(pattern4);
    if (match4) {
      const [, day, month, year, time] = match4;
      return `${year}-${month}-${day} ${time}`;
    }
    
    // Pattern 5: YYYY-MM-DD HH:MM (already correct format)
    const pattern5 = /^(\d{4})-(\d{2})-(\d{2})\s+(\d{2}:\d{2})$/;
    if (pattern5.test(trimmed)) {
      return trimmed;
    }
    
    // Pattern 6: DD-MM-YY (date only, no time)
    const pattern6 = /^(\d{2})-(\d{2})-(\d{2})$/;
    const match6 = trimmed.match(pattern6);
    if (match6) {
      const [, day, month, year] = match6;
      const fullYear = `20${year}`;
      return `${fullYear}-${month}-${day} 00:00`;
    }
    
    // Pattern 7: DD/MM/YY (date only, no time)
    const pattern7 = /^(\d{2})\/(\d{2})\/(\d{2})$/;
    const match7 = trimmed.match(pattern7);
    if (match7) {
      const [, day, month, year] = match7;
      const fullYear = `20${year}`;
      return `${fullYear}-${month}-${day} 00:00`;
    }
    
    return dateStr;
  }

  static async splitCSV(file, batchSize = 100, startRowNo = 1) {
    console.log('🔵 splitCSV called with:', { fileName: file.name, fileSize: file.size, batchSize, startRowNo });
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const csv = e.target.result;
        const lines = csv.split('\n').filter(line => line.trim());
        const headers = lines[0];
        const dataLines = lines.slice(1);
        console.log('📄 CSV parsed:', { totalLines: lines.length, dataRows: dataLines.length, headers, startRowNo });
        
        // Add ROWNO to headers
        const headersWithRowNo = 'ROWNO,' + headers;
        console.log('✅ Headers with ROWNO:', headersWithRowNo);
        
        // Process data lines with ROWNO and date format conversion
        const processedLines = dataLines.map((line, index) => {
          const rowno = startRowNo + index;
          const cells = this.parseCSVLine(line);
          const processedCells = cells.map(cell => {
            const trimmed = cell.trim();
            if (/^\d{1,2}[\/\-]\d{1,2}[\/\-]\d{2,4}(\s+\d{2}:\d{2})?$/.test(trimmed) || /^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}$/.test(trimmed)) {
              const converted = this.convertDateFormat(trimmed);
              console.log('📅 Date converted:', trimmed, '→', converted);
              return converted;
            }
            return trimmed;
          });
          return rowno + ',' + processedCells.map(c => c.includes(',') ? `"${c}"` : c).join(',');
        });
        
        const batches = [];
        for (let i = 0; i < processedLines.length; i += batchSize) {
          const batchLines = processedLines.slice(i, i + batchSize);
          const batchCSV = [headersWithRowNo, ...batchLines].join('\n');
          batches.push({
            data: new Blob([batchCSV], { type: 'text/csv' }),
            index: Math.floor(i / batchSize) + 1,
            rowCount: batchLines.length
          });
        }
        console.log('✨ Batches created:', batches.length, 'batches with', batches.map(b => b.rowCount), 'rows each');
        resolve(batches);
      };
      reader.readAsText(file);
    });
  }
}